import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { useLoadAllItemsQuery } from '@sequencehq/api/utils'
import { useMemo } from 'react'

/**
 * Grabs the usage metrics from the API - will load all pages
 * and append a basic label to the metric. We'll be moving
 * more toward `useQuery` again now that we have a cache,
 * and usageMetrics are a prime candidate to benefit from that!
 * @returns
 */
export const useUsageMetrics = () => {
  const getUsageMetricsQuery = useLoadAllItemsQuery(
    dashboard20240730Client.getUsageMetrics
  )

  const usageMetrics = useMemo(() => {
    if (getUsageMetricsQuery.data) {
      return getUsageMetricsQuery.data.pages
        .flatMap(page => page.items)
        .map(metric => ({
          ...metric,
          label: `${metric.name} (${metric.aggregationType})`
        }))
        .sort((a, b) => a.label.localeCompare(b.label))
    }

    return []
  }, [getUsageMetricsQuery.data])

  return {
    usageMetrics,
    loading: getUsageMetricsQuery.isPending,
    error: getUsageMetricsQuery.isError
  }
}
